import type * as React from "react";

import { cn } from "~/lib/ui/utils/utils";

type ColProps = React.ComponentProps<"div"> & {
  children: React.ReactNode;
};

export function Col({ children, className, ...rest }: ColProps) {
  return (
    <div className={cn("flex flex-col", className)} {...rest}>
      {children}
    </div>
  );
}
